import React from 'react'

export const InfoIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      className='f-c-st-ter'
      xmlns='http://www.w3.org/2000/svg'>
      <circle
        cx='8'
        cy='8'
        r='7'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M8 7.00317V12' strokeLinecap='round' strokeLinejoin='round' />
      <circle cx='8' cy='4.5' r='0.5' />
    </svg>
  )
}
